<div mat-dialog-title class="header">
  <h2>Find FedEx Location</h2>
  @if (!confirmingLocation) {
    <button mat-icon-button mat-dialog-close id="dialog-fedexlocation-close-button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  @if (!confirmingLocation) {
    <div class="search-container">
      <label for="dialog-fedexlocation-search-input" class="sr-only">Search for a FedEx location</label>
      <input
        type="text"
        class="search-box"
        id="dialog-fedexlocation-search-input"
        placeholder="Enter a location"
        [octoGooglePlacesAutocomplete]="octoGooglePlacesAutocomplete"
        (ngModelChange)="onSearchInputChange()"
        (click)="changeCss()"
        (keyup.enter)="searchLocationsManually()"
        [(ngModel)]="searchingFor"
        />
      <button
        class="search-button"
        type="button"
        (click)="searchLocationsManually()"
        id="dialog-fedexlocation-search-button"
        aria-label="Search for FedEx locations"
        >
        <mat-icon aria-hidden="true">search</mat-icon>
      </button>
    </div>
    @if (!fetchingLocations) {
      <p class="location-count">
        <small>
          {{ locations.length === 0 ? 'No locations found' : '' }}
          {{ locations.length === 1 ? '1 location found' : '' }}
          {{
          locations.length > 1
          ? locations.length + ' locations found'
          : ''
          }}
        </small>
      </p>
    }
    @if (locations.length > 0 && !fetchingLocations) {
      <mat-radio-group
        aria-labelledby="ship-to-group-label"
        id="dialog-locations-radiogroup"
        (change)="setSelectedLocation($event)"
        >
        @for (location of locations; track location; let index = $index) {
          <div id="dialog-fedex-location-location-{{index+1}}">
            <octo-fedex-location
              [locationDetails]="location"
            ></octo-fedex-location>
          </div>
        }
      </mat-radio-group>
    }
    @if (fetchingLocations) {
      <div class="loading-spinner-container">
        <mat-spinner diameter="17"></mat-spinner>
        <span>Fetching locations...</span>
      </div>
    }
  }

  @if (confirmingLocation) {
    <div class="loading-spinner-container">
      <mat-spinner diameter="17"></mat-spinner>
      <span>Updating pickup address...</span>
    </div>
  }
</mat-dialog-content>

@if (!confirmingLocation) {
  <mat-dialog-actions>
    <button
      mat-button
      class="btn btn-pink-filled"
      [disabled]="!selectedLocation"
      (click)="confirmLocation()"
      id="dialog-fedexlocation-confirm-button"
      >
      Confirm
    </button>
  </mat-dialog-actions>
}
